import * as jose from 'jose';

export const createJWT = async (decodedKey, payload) => {
    const alg = "RS256";
    const privateKeyPem = await jose.importPKCS8(decodedKey, alg);
    const token = await new jose.SignJWT(payload)
        .setProtectedHeader({ alg })
        .sign(privateKeyPem);
    
    return token
};
